import _get from "lodash/get";
import React, {memo} from "react";
import PropTypes from "prop-types";

import Row from "../../../../../Common/Row";
import Table from "../../../../../Common/Table";
import ConnectedServicesRows from "../../../../../Common/Rows/ConnectedServicesRows";
import EntitlementRows from "../../../../../Common/Rows/EntitlementRows";
import VehicleAddedRows from "../../../../../Common/Rows/VehicleAddedRows";
import OwnerShipRows from "../../../../../Common/Rows/OwnerShipRows";

const Rows = memo(({vehicle}) => {
    return (
        <>
            <Row label={`ID`} value={vehicle.id}/>
            <Row label={`VIN`} value={vehicle.vin}/>
            <Row label={`Brand`} value={vehicle.brand}/>
            <Row label={`Multimedia Device ID`} value={_get(vehicle, `device.id`)}/>
            <Row label={`DCM type`} value={_get(vehicle, `dcmType`)}/>
            <Row label={`License plate`} value={vehicle.licencePlate}/>
            <Row label={`Model`} value={vehicle.model}/>
            <Row label={`Engine`} value={vehicle.engine}/>
            <Row label={`Transmission`} value={vehicle.transmission}/>
            <Row label={`Year`} value={vehicle.year}/>
            <VehicleAddedRows addedOn={vehicle.createdOn} addedBy={vehicle.createdBy} modifiedOn={vehicle.modifiedOn}/>
            <OwnerShipRows claimedOn={vehicle.claimedOn} isOwner={vehicle.isOwner} claimedBy={vehicle.claimedBy}/>
            <EntitlementRows claimedOn={vehicle.entitledOn} entitled={vehicle.isEntitled}
                             claimedBy={vehicle.entitledBy}/>
            <ConnectedServicesRows connectedStatus={vehicle.connectedServiceStatus} privacy={vehicle.privacy}/>
        </>
    );
});

const Vehicle = memo(({vehicle, showSubscriptionForVehicle}) => {
    const AdditionalElementOnTable = _get(vehicle, `device.id`) ? (
        <button
            className="btn btn-sm btn-primary pull-right"
            onClick={() => {
                showSubscriptionForVehicle();
            }}
        >
            Show subscriptions
        </button>
    ) : null;

    return (
        <Table
            title={`Vehicle details - ${vehicle.alias}`}
            icon={`fa fa-car`}
            colorClass={vehicle.isOwner ? `customer-owner` : `customer-not-owner`}
            iconHoverText={`Customer is ${!vehicle.isOwner ? `not ` : ``}the owner of this vehicle`}
            AdditionalElementOnTable={AdditionalElementOnTable}
        >
            <Rows vehicle={vehicle}/>
        </Table>
    );
});
Rows.displayName = `Rows`;
Rows.propTypes = {
    vehicle: PropTypes.object.isRequired
};
Vehicle.displayName = `Vehicle`;
Vehicle.propTypes = {
    vehicle: PropTypes.object.isRequired,
    showSubscriptionForVehicle: PropTypes.func
};

export default Vehicle;
